(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return; // leave everything visible

  var root = document.documentElement;
  root.classList.add('js-anim');

  var SELECTORS = [
    // homepage
    '.hero__content > *', '.featured__head', '.featured__item', '.features__item',
    '.benefits__headings', '.benefits__head > .button', '.benefits__item', '.benefits__media',
    '.noble__head', '.noble__card-wrap', '.noble__cta',
    '.reviews__content', '.brand__head', '.brand__card', '.brand__media', '.cta__content > *',
    // newsletter / support
    '.signup__inner > *', '.support__text', '.support__action',
    // about page
    '.page-hero__head > *', '.page-hero__media', '.imgtext__media', '.imgtext__content',
    '.pstory__head', '.pstory__item', '.quote__inner > *',
    // contact
    '.contact__editorial', '.contact__panel',
    // product page
    '.pdp__gallery', '.pdp__info', '.ritual__media', '.ritual__content',
    '.cycle__text', '.cycle__media', '.after__text', '.after__media',
    '.miy__head', '.miy__item', '.related__head', '.related__item',
    // collection
    '.colbanner__content > *', '.collection__toolbar', '.collection__item',
    // generic hook for custom sections
    '[data-animate]'
  ];

  var zoomSet = {
    'benefits__media': 1, 'brand__media': 1, 'imgtext__media': 1, 'cycle__media': 1,
    'after__media': 1, 'page-hero__media': 1, 'pdp__gallery': 1, 'colbanner__content': 1
  };

  var nodes;
  try {
    nodes = document.querySelectorAll(SELECTORS.join(','));
  } catch (e) {
    return;
  }
  if (!nodes.length) return;

  var list = [];
  Array.prototype.forEach.call(nodes, function (el) {
    if (el.hasAttribute('data-reveal')) return;
    var parent = el.parentElement;
    var delay = 0;
    if (parent) {
      var idx = Array.prototype.indexOf.call(parent.children, el);
      delay = Math.min(idx, 5) * 70;
    }
    var type = '';
    for (var cls in zoomSet) {
      if (el.classList.contains(cls)) { type = 'zoom'; break; }
    }
    el.setAttribute('data-reveal', type);
    el.style.setProperty('--reveal-delay', delay + 'ms');
    list.push(el);
  });

  function revealInView() {
    var vh = window.innerHeight || root.clientHeight;
    for (var i = list.length - 1; i >= 0; i--) {
      var el = list[i];
      var r = el.getBoundingClientRect();
      if (r.top < vh * 0.9 && r.bottom > -40) {
        el.classList.add('is-in');
        list.splice(i, 1);
      }
    }
    if (!list.length) {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    }
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      revealInView();
      ticking = false;
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  window.addEventListener('load', revealInView);
  // initial paint at hidden state, then reveal what's already on screen
  window.setTimeout(revealInView, 60);

  // Smooth in-page anchor scrolling with header offset
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href^="#"]');
    if (!link) return;
    var id = link.getAttribute('href');
    if (id.length < 2) return;
    var target = document.querySelector(id);
    if (!target) return;
    e.preventDefault();
    var header = document.querySelector('[data-header]');
    var offset = header ? header.offsetHeight + 16 : 0;
    var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top: top, behavior: 'smooth' });
  });
})();
